import React from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import BarChartClass from './BarChart';
import DoughnutChartClass from './DoughnutChart';
import LineChartClass from './LineChart';
import LineChart2Class from './LineChart2';
import PolarChartClass from './PolarChart';
import RadarChartClass from './RadarChart';

const ChartsContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='ChartJS Chart' parent='Charts' title='ChartJS Chart' />
      <Row>
        <BarChartClass />
        <LineChartClass />
        <RadarChartClass />
        <LineChart2Class />
        <DoughnutChartClass />
        <PolarChartClass />
      </Row>
    </Container>
  );
};

export default ChartsContainer;
